import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { LuCheck, LuClipboardCopy } from "react-icons/lu";
import Clipboard from "../../../controls/common/clipboard";

// How long the check stays after a copy; envelopeControls.js shows its own for the same time.
const COPIED_MS = 1200;

/**
 * An icon button that copies `text` and shows a check for a moment, the feedback envelopeControls gives.
 *
 * Props:
 *   text  - what to copy
 *   label - the button's name, e.g. "Copy code"
 */
export default class CopyButton extends Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
    this.timer = null;
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  handleCopy = () => {
    Clipboard.to(this.props.text);
    this.setState({ copied: true });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.setState({ copied: false }), COPIED_MS);
  };

  render() {
    // Named by `title`, not the app's Tooltip: docs/specs/2026-10-18-readme-markdown.md#6--code-blocks-copy
    const label = this.state.copied ? "Copied" : this.props.label;
    return (
      <Button variant="light" size="sm" className="playground-icon-button" aria-label={label} title={label}
        onClick={this.handleCopy}>
        {this.state.copied ? <LuCheck /> : <LuClipboardCopy />}
      </Button>
    );
  }
}
